import { useEffect, useState } from "react";

export const useViewportHeight = () => {
  useEffect(() => {
    const setHeight = () => {
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`,
      );
    };

    setHeight(); // Set initially
    window.addEventListener("resize", setHeight);

    return () => window.removeEventListener("resize", setHeight);
  }, []);
};

export const useInnerHeight = () => {
  const [innerHeight, setInnerHeight] = useState(0);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let inv: any = null;
    const setHeight = () => {
      if (innerHeight === window.innerHeight) return;
      setInnerHeight(window.innerHeight);
    };

    setHeight(); // Set initially
    const setHeightDebounced = () => {
      if (inv) clearTimeout(inv);
      inv = setTimeout(setHeight, 100);
    };
    window.addEventListener("resize", setHeightDebounced);

    return () => {
      if (inv) clearTimeout(inv);
      window.removeEventListener("resize", setHeightDebounced);
    };
  }, []);
  return innerHeight;
};

export const useInnerWidth = () => {
  const [innerWidth, setInnerWidth] = useState(0);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let inv: any = null;
    const setWidth = () => {
      if (innerWidth === window.innerWidth) return;
      setInnerWidth(window.innerWidth);
    };

    setWidth(); // Set initially
    const setWidthDebounced = () => {
      if (inv) clearTimeout(inv);
      inv = setTimeout(setWidth, 100);
    };
    window.addEventListener("resize", setWidthDebounced);

    return () => {
      if (inv) clearTimeout(inv);
      window.removeEventListener("resize", setWidthDebounced);
    };
  }, []);
  return innerWidth;
};

export const useInnerSize = () => {
  const [size, setSize] = useState({ innerWidth: 0, innerHeight: 0 });

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let inv: any = null;
    const setSizeValues = () => {
      const { innerWidth, innerHeight } = window;
      setSize((prevSize) => {
        if (
          prevSize.innerWidth === innerWidth &&
          prevSize.innerHeight === innerHeight
        )
          return prevSize;
        return { innerWidth: innerWidth, innerHeight: innerHeight };
      });
    };

    setSizeValues(); // Set initially
    const setSizeDebounced = () => {
      if (inv) clearTimeout(inv);
      inv = setTimeout(setSizeValues, 100);
    };
    window.addEventListener("resize", setSizeDebounced);

    return () => {
      if (inv) clearTimeout(inv);
      window.removeEventListener("resize", setSizeDebounced);
    };
  }, []);

  return size;
};
